export default {"src":"/_next/static/media/tab_calendar.0e96fee6.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};